module.exports = __webpack_public_path__ + "img/20220809163054.e0eab05a.jpg";